import {
  BrowserRouter as Router,
  Routes,
  Route,
  BrowserRouter,
} from "react-router-dom";
import AppHeader from "../components/app/app-header";
import VehicleDetail from "./w_vehicle-page/vehicle-detail/vehicle-detail";
import TyreDetail from "./w_tyre_services/tyre_detail/tyre-detail";
import UserDetail from "./w_admin/UserDetail/user-detail";
import TenantDetail from "./w_sistem/tenant_detail/tenant-detail";
import React from "react";
import WVehicles from './w_vehicle-page/w_vehicles';
import WAlarmVehicle from './w_vehicle-page/w_vehicle-alarms';
import DashboardTyre from './w_tyre_services/dashboard_tyre';
import WTyreService from './w_tyre_services/w_tyre';
import WAlarmTyre from './w_tyre_services/w_tyre_alarm';
import DashboardAdmin from './w_admin/Dashboard';
import AdminListUser from './w_admin/UserList';
import DashboardSystem from './w_sistem/dashboard';
import SystemListTenant from './w_sistem/tenant';
import DashboardVehicle from './w_vehicle-page/dashboard-vehicle';
import AlarmDetailVehicle from './w_vehicle-page/AlarmDetail/AlarmDetail';
import TyreAlarmDetail from './w_tyre_services/AlarmDetailTyre/TyreAlarmDetail';
import { withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css'; // Import Amplify UI styles
import DashboardJourney from './w_journey/journey_dashboard';
import JourneyList from './w_journey/journey_summary';
import GeofencingAlerts from './w_journey/journey_alarms';
import GeolocationBasedData from './w_journey/journey_monitoring_maintenance';
import VehicleTrackingLocation from './w_journey/analytics_hystorical_data_view';
import LoadMonitoring from './w_journey/analytics_predictive_analytics';
import JourneySummary from './w_journey/journey_summary';
import JourneyAlarms from './w_journey/journey_alarms';
import MonitoringMaintenance from './w_journey/journey_monitoring_maintenance';
import HystoricalDataView from './w_journey/analytics_hystorical_data_view';
import PredictiveAnalytics from './w_journey/analytics_predictive_analytics';
import CostSavingEfficiency from './w_journey/analytics_cost_efficiency';
import JourneyReports from './w_journey/reports_journey_reports';
import ExportOptions from './w_journey/reports_export_options';
import ScheduledReports from './w_journey/reports_scheduled_reports';
import JourneyMonitoringMaintenance from './w_journey/journey_monitoring_maintenance';
import JourneyHystoricalDataView from './w_journey/analytics_hystorical_data_view';
import JourneyPredictiveAnalytics from './w_journey/analytics_predictive_analytics';
import JourneyCostSavingEfficiency from './w_journey/analytics_cost_efficiency';
import JourneyScheduledReports from './w_journey/reports_scheduled_reports';
import JourneyExportOptions from './w_journey/reports_export_options';
import TyreScheduledReports from './w_tyre_services/reports_scheduled_reports';
import TyreExportOptions from './w_tyre_services/reports_export_options';
import TyreReports from './w_tyre_services/reports_tyre_reports';
import TyreCostSavingsEfficiency from './w_tyre_services/analytics_cost_savings_efficiency';
import TyrePredictiveAnalytics from './w_tyre_services/analytics_predictive_analytics';
import TyreHystoricalDataView from './w_tyre_services/analytics_hystorical_data_view';
import TyreMonitoringMaintenance from './w_tyre_services/monitoring_maintenance';


import HistoricalDataViewVehicle from './w_vehicle-page/Data_Analytics/historical_data_view';
import DataAnalyticsVehicle from './w_vehicle-page/Data_Analytics';
import PredictiveAnalyticsVehicle from './w_vehicle-page/Data_Analytics/predictive_analytics';
import CostSavingVehicle from './w_vehicle-page/Data_Analytics/cost_saving_efficiency';
import ReportExportingVehicle from './w_vehicle-page/report_exporting';
import ReportVehicle from './w_vehicle-page/report_exporting/reports';
import ExportOptionsVehicle from './w_vehicle-page/report_exporting/export_options';
import ScheduledReportVehicle from './w_vehicle-page/report_exporting/scheduled_report';
import MonitoringMaintenanceVehicle from './w_vehicle-page/monitoring_maintenance';
import DashboardBackend from "./w_backend/dashboard";



function AppContainer() {
  return (
    <>
      <AppHeader />
      <Routes>
          {/* URL Route dom for each workflow*/}
          <Route path="/" index element={<DashboardVehicle />} />
          <Route path="/vehicles" index element={<WVehicles />} />
          <Route path="/vehicles/:VehicleCode" element={<VehicleDetail />} />
          <Route path="/vehicles/alarms" index element={<WAlarmVehicle />} />
          <Route path="/vehicles/alarms/:VehicleCode" index element={<AlarmDetailVehicle />} />
          <Route path="/vehicles/tyres/overview" element={<DashboardTyre onTotalTyreUpdate={function (totalTyres: number): void {
          throw new Error('Function not implemented.');
        } } /> } />
          <Route path="/vehicles/tyres" element={<WTyreService /> } />
          <Route path="/vehicles/tyres/:SerialNumber" element={<TyreDetail /> } />
          <Route path="/vehicles/tyres/alarms" element={<WAlarmTyre /> } />
          <Route path="/vehicles/tyres/alarms/:SerialNumber" element={<TyreAlarmDetail /> } />

          <Route path="/journey" element = {<DashboardJourney />} />
          <Route path="/journey/summary" element = {<JourneySummary />} />
          <Route path="/journey/alarms" element = {<JourneyAlarms />} />
          <Route path="/journey/monitoring-maintenance" element = {<JourneyMonitoringMaintenance />} />
          <Route path="/journey/hystorical-data-view" element = {<JourneyHystoricalDataView />} />
          <Route path="/journey/predictive-analytics" element = {<JourneyPredictiveAnalytics />} />
          <Route path="/journey/cost-saving-efficiency" element = {<JourneyCostSavingEfficiency />} />
          <Route path="/journey/reports" element = {<JourneyReports />} />
          <Route path="/journey/export-options" element = {<JourneyExportOptions />} />
          <Route path="/journey/scheduled-reports" element = {<JourneyScheduledReports />} />
          <Route path="/vehicles/tyres/monitoring-maintenance" element={<TyreMonitoringMaintenance /> } />
          <Route path="/vehicles/tyres/hystorical-data-view" element={<TyreHystoricalDataView /> } />
          <Route path="/vehicles/tyres/predictive-analytics" element={<TyrePredictiveAnalytics /> } />
          <Route path="/vehicles/tyres/cost-savings-efficiency" element={<TyreCostSavingsEfficiency /> } />
          <Route path="/vehicles/tyres/reports" element={<TyreReports /> } />
          <Route path="/vehicles/tyres/export-options" element={<TyreExportOptions /> } />
          <Route path="/vehicles/tyres/scheduled-reports" element={<TyreScheduledReports /> } />
          <Route path='/vehicle/monitoring-maintenance' element={<MonitoringMaintenanceVehicle />} />

          {/* Vehicle data analytics */}
          <Route path='/vehicle/data-analytics' element={<DataAnalyticsVehicle />} />
          <Route path='/vehicle/data-analytics/historical-data-view' element={<HistoricalDataViewVehicle />} />
          <Route path='/vehicle/data-Analytics/predictive-Analytics' element={<PredictiveAnalyticsVehicle />} />
          <Route path='/vehicle/data-Analytics/cost-saving-efficiency' element={<CostSavingVehicle />} />
          {/* vehicle Report exporting */}
          <Route path='/vehicle/report-exporting' element={<ReportExportingVehicle />} />
          <Route path='/vehicle/report-exporting/reports' element={<ReportVehicle />} />
          <Route path='/vehicle/report-exporting/export-options' element={<ExportOptionsVehicle />} />
          <Route path='/vehicle/report-exporting/scheduled-report' element={<ScheduledReportVehicle />} />
          


          <Route path="/admin" element={<DashboardAdmin /> } />
          <Route path="/admin/users" element={<AdminListUser /> } />
          <Route path="/admin/users/:NIK" element={<UserDetail /> } />
        {/* URL Route dom for each workflow*/}
        <Route path="/" index element={<DashboardVehicle />} />
        <Route path="/vehicles" index element={<WVehicles />} />
        <Route path="/vehicles/:VehicleCode" element={<VehicleDetail />} />
        <Route path="/vehicles/alarms" index element={<WAlarmVehicle />} />
        <Route
          path="/vehicles/alarms/:VehicleCode"
          index
          element={<AlarmDetailVehicle />}
        />

        <Route path="/vehicles/tyres/overview" element={<DashboardTyre onTotalTyreUpdate={function (totalTyres: number): void {
          throw new Error("Function not implemented.");
        } } />} />
        <Route path="/vehicles/tyres" element={<WTyreService />} />
        <Route path="/vehicles/tyres/:SerialNumber" element={<TyreDetail />} />
        <Route path="/vehicles/tyres/alarms" element={<WAlarmTyre />} />
        <Route
          path="/vehicles/tyres/alarms/:SerialNumber"
          element={<TyreAlarmDetail />}
        />

        <Route path="/admin" element={<DashboardAdmin />} />
        <Route path="/admin/users" element={<AdminListUser />} />
        <Route path="/admin/users/:NIK" element={<UserDetail />} />

        <Route path="/admin" element={<DashboardAdmin />} />
        <Route path="/admin/users" element={<AdminListUser />} />
        <Route path="/admin/users/:NIK" element={<UserDetail />} />

        <Route path="/system" element={<DashboardSystem />} />
        <Route path="/system/tenants" element={<SystemListTenant />} />
        <Route path="/system/tenants/:TenantName" element={<TenantDetail />} />

        <Route path="/backend" element={<DashboardBackend />} />

        {/* <Route path="/Detail/:name" element={<ItemDetailPage data={dataUnit} />} /> add detail page using parameter from name of unit clicked on list units or alarm table */}
        <Route path="*" element={<DashboardVehicle />} />
      </Routes>
    </>
  );
}

export default withAuthenticator(AppContainer);
